import { cx } from "class-variance-authority";
import type { ComponentProps } from "react";

export function Spinner({ className, ...props }: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			className={cx("spinner animate-spinner", className)}
			{...props}
		>
			<circle
				className="path"
				cx="12"
				cy="12"
				r="6"
				fill="none"
				stroke="currentColor"
				strokeWidth="2.5"
			/>
		</svg>
	);
}
